import Component from './components/main'


export default Component
